export const ATTRIBUTES = Symbol('attributes')
